module.exports = __webpack_public_path__ + "img/7_184.42870c4c.png";